<template>
    <div class="control">
        <div class="form-group input-group" v-bind:class="{'zipcode-error': errors.has('zipcode') }">
            <input id="zipcode" name="zipcode" v-validate="{max:5,min:5}" class="form-control" type="number" v-model="query" v-bind:placeholder="control.placeholder" v-on:keyup.enter="updateFilters" v-on:blur="updateFilters2" />
            <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" v-on:click="updateFilters">
                    <span class="icon-search"></span>
                    <span class="sr-only">Search</span>
                </button>
            </div>
        </div>
        <span v-show="errors.has('zipcode')" class="error">{{ errors.first('zipcode') }}</span>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex';

    export default {
        props: ['control', 'parent'],
        data: function () {
            return {
                query: this.control.defaultValue,
            }
        },
        inject: {
            $validator: '$validator'
        },
        mounted: function () {
            let initialData = this.$store.state.listing.specification[this.parent.specification];
            if (initialData !== '') {
                this.query = initialData;
            }
            // clear current input on reset
            this.$store.subscribe((mutation, state) => {
                if (mutation.type === 'listing/resetSpecification') {
                    this.query = this.parent.defaultValue;
                }
            });

            this.$store.subscribe((mutation, state) => {
                if (mutation.type === 'listing/updateSpecification') {
                    if (state.listing.specification.StateCode !== null && this.parent.specification === 'Zipcode') {
                        this.query = this.parent.defaultValue;
                    }
                }
            });
        },
        methods: {
            ...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
            updateFilters() {
                // if hitting api on each checkmark change
                //Yahya Alani
                //9/1/2021
                //Added Zip code validation to validate if textbox has value in it upon clicking search button. Ticket#208002
                var zip = document.getElementById("zipcode")
                if (zip.value == '') {
                    alert("Zip code required!")
                    return false;
                } else {
                    this.$validator.validateAll().then((result) => {
                        console.log(result);
                        if (result) {
                            this.updateSpecification({ key: this.parent.specification, value: this.query });
                        }
                    });
                }
            },
            ...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
            updateFilters2() {
                // if hitting api on each checkmark change
                //Yahya Alani
                //10/12/2021
                //Resetting result on zip code field blur event to all states list. Ticket#213781
                var zip = document.getElementById("zipcode")
                if (zip.value == '') {
                    this.$validator.validateAll().then((result) => {
                        console.log(result);
                        if (result) {
                            this.updateSpecification({ key: this.parent.specification, value: this.query });
                        }
                    });
                }

            },
        }
    }
</script>